import { render, staticRenderFns } from "./RecruiterAgencyModal.vue?vue&type=template&id=236e21ea"
import script from "./RecruiterAgencyModal.vue?vue&type=script&lang=js"
export * from "./RecruiterAgencyModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports